<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import { computed } from 'vue';
import {
  buildOfferMessage,
  buildIntroductionMessage,
} from '../utils/agendaQuickActions';
import { normalizeHouseContacts } from 'dashboard/helper/lais/imovelPresenter';
import ContactCard from './ContactCard.vue';

const props = defineProps({
  contacts: { type: Array, default: () => [] },
  visit: { type: Object, default: () => ({}) },
  imovel: { type: Object, default: () => ({}) },
  accountId: { type: [String, Number], default: '' },
  agentName: { type: String, default: 'Imudei' },
  companyName: { type: String, default: 'Imudei' },
});

const items = computed(() =>
  normalizeHouseContacts({
    contacts: props.contacts.length ? props.contacts : null,
    visit: props.visit,
    imovel: props.imovel,
  })
);

const messageFor = contact =>
  contact.canSendOffer
    ? buildOfferMessage({
        accountId: props.accountId,
        visit: props.visit,
      })
    : buildIntroductionMessage({
        visit: props.visit,
        agentName: props.agentName,
        companyName: props.companyName,
      });
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text, vue/no-root-v-if -->
  <section class="contents">
    <div v-if="items.length" class="grid gap-3">
      <div>
        <h3 class="text-[16px] font-semibold text-lais-text">
          Contatos da casa
        </h3>
        <p class="mt-1 text-[12px] leading-relaxed text-lais-text-muted">
          Regras de visibilidade aplicadas por papel e fonte do anúncio.
        </p>
      </div>
      <div class="grid gap-3 md:grid-cols-2">
        <ContactCard
          v-for="contact in items"
          :key="contact.id"
          :contact="contact"
          :message="messageFor(contact)"
        />
      </div>
    </div>
  </section>
</template>
